






































































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { Analysis, FarmAnalysis } from "@/api/analyses/types";
import CropIcons from "@/utils/iconCropTypes";
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";
import i18n from "@/i18n";
import AnalysisStatusController from "@/components/analysis-status/AnalysisStatusController.vue";
import AnalysisDelete from '@/components/analyses-delete/AnalysisDelete.vue';
import { zonedTimeToUtc, toDate } from "date-fns-tz";

@Component({
  name: "FarmViewAnalysesItem",
  components: {
    AgroIcons,
    AnalysisStatusController,
    AnalysisDelete,
  },
  filters: {
    formatDateTime(date: Date) {
      if (!date) {
        return "";
      } else {
        const dateAux = zonedTimeToUtc(date, "Etc/UTC");
        return i18n.d(toDate(dateAux), "datetime-short");
      }
    },
  },
})
export default class AnalysisItem extends Vue {
  @Prop({ type: Object, required: true })
  private analysis!: Analysis;

  private get cropTypeIconName() {
    return CropIcons.fromText(this.analysis.cropType);
  }

  @Emit('analysis:delete')
  private analyisDeleted() {}

  private get sentinelaFarmAnalysis(): FarmAnalysis | null {
    return (
      this.analysis?.farmAnalyses.find(
        (fa) => fa.analysisType === "SENTINELA"
      ) ?? null
    );
  }

  private get analiticaFarmAnalysis(): FarmAnalysis | null {
    return (
      this.analysis?.farmAnalyses.find(
        (fa) => fa.analysisType === "ANALITICA"
      ) ?? null
    );
  }

  private get isStillMonitored() {
    return (
      !!this.sentinelaFarmAnalysis &&
      (this.sentinelaFarmAnalysis.analysisYear === 2023 ||
      !this.sentinelaFarmAnalysis.isFinished)
    );
  }
}
